<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="header">
        <span>错别字替换</span>
        <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      </div>
      <div class="body">
        <div class="content">
          <div class="normal" v-html="content.content"></div>
        </div>
        <div class="typos">
          <p class="title">可选择自动或者手动替换</p>
          <div class="line titleline">
            <div>
              <img @click="switchCheckAll()" class="checker" :src="checkAll?icons.on:icons.off" alt="icon">
              <span class="error">错误内容</span>
              <span class="replacer">替换内容</span>
            </div>
          </div>
          <div class="linewrapper">
            <div class="line" v-for="(i, k) in content.errors" :key="k">
              <div>
                <img @click="switchCheker(i)" class="checker" :src="i.checked?icons.on:icons.off" alt="icon">
                <span class="error">{{i.errWord}}</span>
                <!-- <span class="replacer">123</span> -->
                <input class="replacer" type="text" v-model="i.referenceWord">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <p class="btn green" @click="confirm()">替换</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'

export default {
  name: 'success',
  data() {
    return {
      show: true,
      icons: {
        on: require('@assets/img/interview/checkerOn.svg'),
        off: require('@assets/img/interview/checker.svg')
      },
      checkAll: false,
      content: {
        type: 0,
        content: '',
        errors: []
      },
      r: null,
      markTag: '<mark></mark>'
    }
  },
  methods: {
    open(content, r) {
      window.document.body.style.overflowY = 'hidden'
      content.errors = content.errors.map(i => {
        i.referenceWord = common.cleanAllAngles(i.referenceWord)
        return i
      })

      this.content = content
      this.markAllWords(this.content)
      this.r = r
      this.show = true
    },
    markAllWords(content) {
      // 为每个词添加mark
      content.errors.forEach((i, d) => {
        this.addMark(i, d)
      })
    },
    addMark(w, d) {
      this.replaceWord(w.errWord, w.pos)

      this.content.errors.forEach((i, k) => {
        if (k > d) {
          i.pos = i.pos + this.markTag.length
        }
      })
    },
    close() {
      window.document.body.style.overflowY = 'auto'
      this.show = false
    },
    replacePs(content) {
      // 去掉内容中的p标签
      return content.replace(/\<p\>/g, '').replace(/\<\/p\>/g, '\n')
    },
    replaceBRs(content) {
      // 去掉内容中的br标签
      return content.replace(/\<br\/\>/g, '\n')
    },
    async confirm() {
      let msg = '是否确认替换？'

      if (this.content.errors.filter(i => i.checked).filter(i => !i.referenceWord).length > 0) {
        msg = '如果替换内容为空，将删除该错别字。'
      }

      let num = 0;

      this.content.errors.forEach(el => {
        if(el.checked){
          num++
        }
      })

      if(num > 0){
        const c = await this.$confirm(msg)
        if (!c) return

        let content = this.replaceErrors()
        if (this.content.type == 1 || this.content.type == 2 || this.content.type == 4) {
          content = this.replacePs(content)
          content = this.replaceBRs(content)
        }

        const contentData = {
          content: content,
          body: '',
          lead: '',
          after: ''
        }
        // contentData.body = common.getBody(content).replace('\n', '')
        // contentData.lead = common.getLead(content).replace('\n', '')
        // contentData.after = common.getAfter(content).replace('\n', '')
        if(this.content.type == 4){
          contentData.body = this.dropTVEnds(common.getBody1(content))
          contentData.lead = this.dropTVEnds(common.getLead1(content))
          contentData.after = this.dropTVEnds(common.getAfter1(content))
        }else{
          contentData.body = this.dropTVEnds(common.getBody(content))
          contentData.lead = this.dropTVEnds(common.getLead(content))
          contentData.after = this.dropTVEnds(common.getAfter(content))
        }

        this.r(contentData)
        this.close()
      }else{
        let content = this.replaceErrors()
        if (this.content.type == 1 || this.content.type == 2 || this.content.type == 4) {
          content = this.replacePs(content)
          content = this.replaceBRs(content)
        }

        const contentData = {
          content: content,
          body: '',
          lead: '',
          after: ''
        }
        // contentData.body = common.getBody(content).replace('\n', '')
        // contentData.lead = common.getLead(content).replace('\n', '')
        // contentData.after = common.getAfter(content).replace('\n', '')
        // contentData.body = this.dropTVEnds(common.getBody(content))
        // contentData.lead = this.dropTVEnds(common.getLead(content))
        // contentData.after = this.dropTVEnds(common.getAfter(content))
        if(this.content.type == 4){
          contentData.body = this.dropTVEnds(common.getBody1(content))
          contentData.lead = this.dropTVEnds(common.getLead1(content))
          contentData.after = this.dropTVEnds(common.getAfter1(content))
        }else{
          contentData.body = this.dropTVEnds(common.getBody(content))
          contentData.lead = this.dropTVEnds(common.getLead(content))
          contentData.after = this.dropTVEnds(common.getAfter(content))
        }

        this.r(contentData)
        this.close()
      }
    },
    dropTVEnds(part) {
      // 去除电视稿替换错别字之后的前后多余换行（各一个）
      return part.replace('\n', '').replace(/\n$/, '')
    },
    cancel() {
      this.r(null)
      this.close()
    },
    cleanMark() {
      // 清除mark
      const content = this.content.content

      this.content.content = content.replace(/\<mark\>/g, '').replace(/\<\/mark\>/g, '')
    },
    replaceWord(word, start) {
      //  将需要标注的词用标签标注，并替换到文本中
      const content = this.content.content

      this.content.content = `${content.substring(0, start)}<mark>${word}</mark>${content.substring(start + word.length)}`
    },
    replaceMark(word, fixed, start, index) {
      //  将错别字标注替换回来
      const content = this.content.content

      this.content.content = `${content.substring(0, start)}${fixed}${content.substring(start + word.length + this.markTag.length)}`

      const diff = `<mark>${word}</mark>`.length - fixed.length

      this.content.errors.forEach((i, d) => {
        if (d > index) {
          i.pos = i.pos - diff
        }
      })
    },
    replaceErrors() {
      // 将稿件内容中的错别字替换为修改后的
      // let content = this.content.content

      this.content.errors.forEach((i, d) => {
        if (i.checked) {
          this.replaceMark(i.errWord, i.referenceWord, i.pos, d)
        }
      })

      this.cleanMark()

      return this.content.content
    },
    switchCheckAll() {
      this.checkAll = !this.checkAll

      this.$nextTick(() => {
        if (this.checkAll) {
          this.content.errors.forEach((i)=>{
            this.$set(i, 'checked', true)
          })
        } else {
          this.content.errors.forEach((i)=>{
            this.$set(i, 'checked', false)
          })
        }
      })
    },
    switchCheker(i) {
      this.$set(i, 'checked', !i.checked)
    },
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    height: 600px;
    min-width: 1000px;
    max-width: 1200px;
    margin: 0 100px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 30px;
    .header {
      height: 34px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      font-weight: bold;
    }
    .body {
      margin: 30px 0;
      flex: 1;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      .content, .typos {
        height: 100%;
        flex: 1;
        border-radius: 4px;
        overflow-y: auto;
      }
      .content {
        margin-right: 20px;
        background-color: rgba(185, 195, 195, 0.2);
        padding: 26px 20px;
      }
      .content/deep/mark{
        background-color: transparent;
        color: @red;
      }
      .normal/deep/img, .normal/deep/video {
        max-width: 100%;
      }
      .typos {
        // border: 1px solid @dateColor;
        border: 1px solid #DCDCDC;
        display: flex;
        flex-direction: column;
        .title {
          width: inherit;
          background-color: @bg;
          height: 50px;
          line-height: 50px;
          padding: 0 20px;
          font-size: 16px;
          // font-weight: bold;
          background: #f9f9f9;
          box-shadow: 4px 4px 10px rgba(5,10,15,0.05);
        }
        .titleline {
          span {
            color: @sub;
            font-size: 13px !important;
            background-color: transparent !important;
          }
          &:hover {
            background-color: transparent !important;
          }
        }
        .linewrapper {
          flex: 1;
          overflow-y: auto;
        }
        .line {
          height: 50px;
          padding: 0 20px;
          font-size: 14px;
          display: flex;
          align-items: center;
          cursor: pointer;
          box-sizing: border-box;
          div {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 1px solid #DCDCDC;
            box-sizing: border-box;
          }
          .checker {
            margin-right: 34px;
          }
          .error {
            flex: 1;
            padding-right: 30px;
          }
          .replacer {
            width: 0;
            flex: 1;
            font-size: 14px;
            margin-right: 80px;
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            background-color: rgba(6, 21, 50, 0.05);
            border-radius: 4px;
          }
          &:hover {
            background-color: rgba(185, 195, 195, 0.15);
          }
        }
      }
    }
    .footer {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .close {
      cursor: pointer;
    }
    .btn {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
  }
</style>
